import React, { Ref } from 'react';
import { ImperativeAPI } from '../types/imperative-api';
import { ImageField } from '../image-components/image-field';
import { useSignatureImageAlt } from './use-signature-image-alt';

type Props = {
  signer: string;
  signatureGuid: string;
  isFormView?: boolean;
};
function SignatureImageInternal(
  { isFormView, signer, signatureGuid }: Props,
  ref: Ref<ImperativeAPI>,
) {
  const altTextMessage = useSignatureImageAlt({ signer });

  return (
    <ImageField
      isFormView={isFormView}
      alt={altTextMessage}
      id={signatureGuid}
      ref={ref}
    />
  );
}

export const SignatureImage = React.forwardRef(SignatureImageInternal);
